<template>
  <div
    class="mediaLibraryModalCard"
    v-on:click="onClick"
    v-bind:class="{ mediaSelected: selected}"
  >
    <img :src="src" width="150" />
    {{media.title}}
  </div>
</template>

<script>
export default {
  props: {
    selected: {
      type: Boolean,
      default: false,
    },
    media: {
      type: Object,
      default: function () {
        return {
          id: "",
          title: "",
          filename: "",
        };
      },
    },
  },
  computed: {
    src() {
      return (
        process.env.VUE_APP_API_URL +
        "/media/thumbnails/300/" +
        this.media.id +
        ".png"
      );
    },
  },
  methods: {
    onClick() {
      this.$emit("selected", this.media.id);
    },
  },
};
</script>

<style scoped>
.mediaLibraryModalCard {
  border-style: solid;
  border-width: 1px;
  cursor: pointer;
}
.mediaSelected {
  border-width: 3px;
  border-color: green;
}
</style>